import React, { useMemo } from "react";
import classNames from "classnames";
import "../styles/index.css";
import { Izstar } from "../Izstar";
import { kot, t } from "iztro/lib/i18n";
import { fixIndex } from "iztro/lib/utils";
export const Izpalace = ({ index, taichiPalace, focusedIndex, onFocused, horoscope, activeHeavenlyStem, toggleActiveHeavenlyStem, hoverHeavenlyStem, setHoverHeavenlyStem, showDecadalScope = false, showYearlyScope = false, showMonthlyScope = false, showDailyScope = false, showHourlyScope = false, toggleScope, toggleTaichiPoint, ...palace }) => {
    const horoscopeNames = useMemo(() => {
        const horoscopeNames = [];
        if (horoscope?.decadal.index === index) {
            horoscopeNames.push({
                ...horoscope.decadal,
                scope: "decadal",
                show: showDecadalScope,
            });
        }
        if (horoscope?.yearly.index === index) {
            horoscopeNames.push({
                ...horoscope.yearly,
                scope: "yearly",
                show: showYearlyScope,
            });
        }
        if (horoscope?.monthly.index === index) {
            horoscopeNames.push({
                ...horoscope.monthly,
                scope: "monthly",
                show: showMonthlyScope,
            });
        }
        if (horoscope?.daily.index === index) {
            horoscopeNames.push({
                ...horoscope.daily,
                scope: "daily",
                show: showDailyScope,
            });
        }
        if (horoscope?.hourly.index === index) {
            horoscopeNames.push({
                ...horoscope.hourly,
                scope: "hourly",
                show: showHourlyScope,
            });
        }
        if (horoscope?.age.index === index) {
            horoscopeNames.push({
                name: horoscope.age.name,
                heavenlyStem: undefined,
                scope: "age",
                show: false,
            });
        }
        return horoscopeNames;
    }, [
        horoscope,
        showDecadalScope,
        showYearlyScope,
        showMonthlyScope,
        showDailyScope,
        showHourlyScope,
    ]);
    const horoscopeMutagens = useMemo(() => {
        if (!horoscope) {
            return [];
        }
        return [
            {
                mutagen: horoscope.decadal.mutagen,
                scope: "decadal",
                show: showDecadalScope,
            },
            {
                mutagen: horoscope.yearly.mutagen,
                scope: "yearly",
                show: showYearlyScope,
            },
            {
                mutagen: horoscope.monthly.mutagen,
                scope: "monthly",
                show: showMonthlyScope,
            },
            {
                mutagen: horoscope.daily.mutagen,
                scope: "daily",
                show: showDailyScope,
            },
            {
                mutagen: horoscope.hourly.mutagen,
                scope: "hourly",
                show: showHourlyScope,
            },
        ];
    }, [
        horoscope,
        showDecadalScope,
        showYearlyScope,
        showMonthlyScope,
        showDailyScope,
        showHourlyScope,
    ]);
    return (React.createElement("div", { className: classNames(`iztro-palace g${index}`, {
            "focused-palace": focusedIndex === index,
            "opposite-palace": focusedIndex != undefined && index === fixIndex(focusedIndex + 6),
            "surrounded-palace": focusedIndex != undefined &&
                (index === fixIndex(focusedIndex + 4) ||
                    index === fixIndex(focusedIndex - 4)),
        }), onMouseEnter: () => onFocused?.(index), onMouseLeave: () => onFocused?.(undefined) },
        React.createElement("div", { className: classNames("iztro-palace-major") }, palace.majorStars.map((star) => (React.createElement(Izstar, { key: star.name, activeHeavenlyStem: activeHeavenlyStem, hoverHeavenlyStem: hoverHeavenlyStem, palaceHeavenlyStem: kot(palace.heavenlyStem, "Heavenly"), horoscopeMutagens: horoscopeMutagens, ...star })))),
        React.createElement("div", { className: classNames("iztro-palace-minor") }, palace.minorStars.map((star) => (React.createElement(Izstar, { key: star.name, activeHeavenlyStem: activeHeavenlyStem, hoverHeavenlyStem: hoverHeavenlyStem, palaceHeavenlyStem: kot(palace.heavenlyStem, "Heavenly"), horoscopeMutagens: horoscopeMutagens, ...star })))),
        React.createElement("div", { className: classNames("iztro-palace-adj") },
            React.createElement("div", null, palace.adjectiveStars.slice(5).map((star) => (React.createElement(Izstar, { key: star.name, ...star })))),
            React.createElement("div", null, palace.adjectiveStars.slice(0, 5).map((star) => (React.createElement(Izstar, { key: star.name, ...star }))))),
        React.createElement("div", { className: classNames("iztro-palace-horo-star") },
            React.createElement("div", { className: classNames("stars") }, horoscope?.decadal?.stars &&
                horoscope?.decadal?.stars[index].map((star) => (React.createElement(Izstar, { key: star.name, ...star })))),
            React.createElement("div", { className: classNames("stars") }, horoscope?.yearly?.stars &&
                horoscope?.yearly?.stars[index].map((star) => (React.createElement(Izstar, { key: star.name, ...star }))))),
        React.createElement("div", { className: classNames("iztro-palace-fate") }, horoscopeNames?.map((item) => (React.createElement("span", { key: item.name, className: classNames({
                [`iztro-palace-${item.scope}-active`]: item.show,
            }), onClick: item.scope ? () => toggleScope?.(item.scope) : undefined },
            item.name,
            item.heavenlyStem && `·${item.heavenlyStem}`)))),
        React.createElement("div", { className: classNames("iztro-palace-footer") },
            React.createElement("div", null,
                React.createElement("div", { className: classNames("iztro-palace-lft24") },
                    React.createElement("div", null, palace.changsheng12),
                    React.createElement("div", null, palace.boshi12)),
                React.createElement("div", { className: classNames("iztro-palace-name"), onClick: () => toggleTaichiPoint?.(index) },
                    React.createElement("span", { className: "iztro-palace-name-wrapper" },
                        palace.name,
                        React.createElement("span", { className: "iztro-palace-name-taichi" }, taichiPalace &&
                            (kot(taichiPalace) === kot("命宫")
                                ? "☯"
                                : taichiPalace))),
                    palace.isBodyPalace && (React.createElement("span", { className: classNames("iztro-palace-name-body") },
                        "\u00B7",
                        t("bodyPalace"))))),
            React.createElement("div", null,
                React.createElement("div", { className: classNames("iztro-palace-scope") },
                    React.createElement("div", { className: classNames("iztro-palace-scope-age") }, palace.ages.slice(0, 7).join(" ")),
                    React.createElement("div", { className: classNames("iztro-palace-scope-decadal") }, palace.decadal.range.join(" - "))),
                React.createElement("div", { className: classNames("iztro-palace-dynamic-name") },
                    showDecadalScope && (React.createElement("span", { className: "iztro-palace-dynamic-name-decadal" }, horoscope?.decadal.palaceNames[index])),
                    showYearlyScope && (React.createElement("span", { className: "iztro-palace-dynamic-name-yearly" }, horoscope?.yearly.palaceNames[index])),
                    showMonthlyScope && (React.createElement("span", { className: "iztro-palace-dynamic-name-monthly" }, horoscope?.monthly.palaceNames[index])),
                    showDailyScope && (React.createElement("span", { className: "iztro-palace-dynamic-name-daily" }, horoscope?.daily.palaceNames[index])),
                    showHourlyScope && (React.createElement("span", { className: "iztro-palace-dynamic-name-hourly" }, horoscope?.hourly.palaceNames[index])))),
            React.createElement("div", null,
                React.createElement("div", { className: classNames("iztro-palace-rgt24") },
                    React.createElement("div", null, showYearlyScope
                        ? horoscope?.yearly.yearlyDecStar.suiqian12[index]
                        : palace.suiqian12),
                    React.createElement("div", null, showYearlyScope
                        ? horoscope?.yearly.yearlyDecStar.jiangqian12[index]
                        : palace.jiangqian12)),
                React.createElement("div", { className: classNames("iztro-palace-gz", {
                        "iztro-palace-gz-active": activeHeavenlyStem ===
                            kot(palace.heavenlyStem, "Heavenly"),
                    }), onClick: () => toggleActiveHeavenlyStem?.(kot(palace.heavenlyStem, "Heavenly")), onMouseEnter: () => setHoverHeavenlyStem?.(kot(palace.heavenlyStem, "Heavenly")), onMouseLeave: () => setHoverHeavenlyStem?.(undefined) },
                    React.createElement("span", { className: classNames({
                            "iztro-palace-gz-active": activeHeavenlyStem ===
                                kot(palace.heavenlyStem, "Heavenly"),
                        }) },
                        palace.heavenlyStem,
                        palace.earthlyBranch))))));
};
